var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.789,
    height: 29.63,
    viewBox: "-3543.5 -282.5 28.789 29.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "_icons"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3514.831-270.328c-.16-.16-.16-.32-.32-.48l-3.204-3.203c-.64-.641-1.601-.641-2.242 0-.64.64-.64 1.601 0 2.242l.48.48h-4.164c-.96 0-1.601.64-1.601 1.602 0 .96.64 1.602 1.601 1.602h4.165l-.481.48c-.64.64-.64 1.602 0 2.242.32.32.8.48 1.121.48.32 0 .801-.16 1.121-.48l3.204-3.203c.16-.16.32-.32.32-.48.16-.48.16-.801 0-1.282Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3514.831-270.328c-.16-.16-.16-.32-.32-.48l-3.204-3.203c-.64-.641-1.601-.641-2.242 0-.64.64-.64 1.601 0 2.242l.48.48h-4.164c-.96 0-1.601.64-1.601 1.602 0 .96.64 1.602 1.601 1.602h4.165l-.481.48c-.64.64-.64 1.602 0 2.242.32.32.8.48 1.121.48.32 0 .801-.16 1.121-.48l3.204-3.203c.16-.16.32-.32.32-.48.16-.48.16-.801 0-1.282Z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#fff",
    fill: "transparent"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3522.68-264.882c-.96 0-1.6.64-1.6 1.601v1.602c0 .96-.641 1.602-1.602 1.602h-1.602v-13.774c0-2.082-1.281-3.844-3.043-4.485l-2.563-.96h7.208c.96 0 1.601.64 1.601 1.6v1.602c0 .961.641 1.602 1.602 1.602.96 0 1.602-.64 1.602-1.602v-1.601c0-2.723-2.083-4.805-4.805-4.805h-16.016c-.16 0-.32 0-.48.16-.161 0-.321.16-.321.16l-.16.16c-.16 0-.32.16-.32.32v.161c-.16 0-.321.16-.321.32v22.743c0 .64.48 1.281.961 1.442l10.57 4.004c.32.16.801.16 1.122.16.64 0 1.281-.16 1.762-.64.8-.641 1.441-1.602 1.441-2.563v-.801h1.602c2.722 0 4.804-2.082 4.804-4.805v-1.602c.16-.8-.48-1.601-1.441-1.601Zm-17.617 5.285v-19.06l8.489 3.204c.64.32 1.12.961 1.12 1.602v17.778l-9.609-3.524Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3522.68-264.882c-.96 0-1.6.64-1.6 1.601v1.602c0 .96-.641 1.602-1.602 1.602h-1.602v-13.774c0-2.082-1.281-3.844-3.043-4.485l-2.563-.96h7.208c.96 0 1.601.64 1.601 1.6v1.602c0 .961.641 1.602 1.602 1.602.96 0 1.602-.64 1.602-1.602v-1.601c0-2.723-2.083-4.805-4.805-4.805h-16.016s0 0 0 0c-.16 0-.32 0-.48.16 0 0 0 0 0 0-.161 0-.321.16-.321.16s0 0 0 0l-.16.16c-.16 0-.32.16-.32.32v.161c-.16 0-.321.16-.321.32 0 0 0 0 0 0v22.743c0 .64.48 1.281.961 1.442l10.57 4.004c.32.16.801.16 1.122.16.64 0 1.281-.16 1.762-.64.8-.641 1.441-1.602 1.441-2.563v-.801h1.602c2.722 0 4.804-2.082 4.804-4.805v-1.602c.16-.8-.48-1.601-1.441-1.601Zm-17.617 5.285v-19.06l8.489 3.204c.64.32 1.12.961 1.12 1.602v15.375s0 0 0 0v2.403l-9.609-3.524Z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#fff",
    fill: "transparent"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.86750fa750937c17400467e3c1840674.svg";
export { ForwardRef as ReactComponent };